const map = {
	"./en/copyright-statement.md": 44,
	"./en/get-started.md": 7341,
	"./en/onsale-rules.md": 1381,
	"./spine-data-model.md": 6419,
	"./zh/copyright-statement.md": 7673,
	"./zh/get-started.md": 2740,
	"./zh/onsale-rules.md": 762,
	"docs/en/copyright-statement.md": 44,
	"docs/en/get-started.md": 7341,
	"docs/en/onsale-rules.md": 1381,
	"docs/spine-data-model.md": 6419,
	"docs/zh/copyright-statement.md": 7673,
	"docs/zh/get-started.md": 2740,
	"docs/zh/onsale-rules.md": 762
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6222;